import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/xxjj',
    name: 'xxjj',
    component: () => import('../views/xxgg/xxjj.vue')
  }, {
    path: '/bxlj',
    name: 'bxlj',
    component: () => import('../views/xxgg/bxlj.vue')
  }, {
    path: '/xyhj',
    name: 'xyhj',
    component: () => import('../views/xxgg/xyhj.vue')
  },
  {
    path: '/xxyw',
    name: 'xxyw',
    component: () => import('../views/xwdt/xxyw.vue')
  },
  {
    path: '/mtjj',
    name: 'mtjj',
    component: () => import('../views/xwdt/mtjj.vue')
  }, {
    path: '/mtjjDetail',
    name: 'mtjjDetail',
    component: () => import('../views/xwdt/mtjjDetail.vue')
  },
  {
    path: '/spzq',
    name: 'spzq',
    component: () => import('../views/xwdt/spzq.vue')
  },
  {
    path: '/xwxq',
    name: 'xwxq',
    component: () => import('../views/xwdt/xwxq.vue')
  },
  {
    path: '/zzjsDetail',
    name: 'zzjsDetail',
    component: () => import('../views/djgz/zzjsDetail.vue')
  }, {
    path: '/zzjs',
    name: 'zzjs',
    component: () => import('../views/djgz/zzjs.vue')
  }, {
    path: '/dyhd',
    name: 'dyhd',
    component: () => import('../views/djgz/dyhd.vue')
  }, {
    path: '/dyhdDetail',
    name: 'dyhdDetail',
    component: () => import('../views/djgz/dyhdDetail.vue')
  },

  // {
  //   path: '/xxgw',
  //   name: 'xxgw',
  //   component: () => import('../views/gltd/.vue')
  // }, 
  {
    path: '/tdgl',
    name: 'tdgl',
    component: () => import('../views/gltd/tdgl.vue')
  }, {
    path: '/gwxq',
    name: 'gwxq',
    component: () => import('../views/gltd/gwxq.vue')
  },
  {
    path: '/jsdb',
    name: 'jsdb',
    component: () => import('../views/jsfc/jsdb.vue')
  },
  {
    path: '/jshdDetail',
    name: 'jshdDetail',
    component: () => import('../views/jsfc/jshdDetail.vue')
  },
  {
    path: '/jshd',
    name: 'jshd',
    component: () => import('../views/jsfc/jshd.vue')
  },
  {
    path: '/jsry',
    name: 'jsry',
    component: () => import('../views/jsfc/jsry.vue')
  },
  {
    path: '/jsryDetail',
    name: 'jsryDetail',
    component: () => import('../views/jsfc/jsryDetail.vue')
  }, {
    path: '/keyan',
    name: 'keyan',
    component: () => import('../views/jsfc/keyan.vue')
  },
  {
    path: '/keyanDetail',
    name: 'keyanDetail',
    component: () => import('../views/jsfc/keyandetail.vue')
  },
  {
    path: '/jsfz',
    name: 'jsfz',
    component: () => import('../views/jsfc/jsfz.vue')
  },
  {
    path: '/sksp',
    name: 'sksp',
    component: () => import('../views/jsfc/sksp.vue')
  },
  {
    path: '/jscy',
    name: 'jscy',
    component: () => import('../views/jsfc/jscy.vue')
  },
  // jsDetail
  {
    path: '/jsDetail',
    name: 'jsDetail',
    component: () => import('../views/jsfc/jsDetail.vue')
  },
  {
    path: '/czkc',
    name: 'czkc',
    component: () => import('../views/kcjs/czkc.vue')
  },
  {
    path: '/gzkc',
    name: 'gzkc',
    component: () => import('../views/kcjs/gzkc.vue')
  },
  {
    path: '/xxkc',
    name: 'xxkc',
    component: () => import('../views/kcjs/xxkc.vue')
  },
  {
    path: '/shuangyu',
    name: 'shuangyu',
    component: () => import('../views/kcjs/shuangyu.vue')
  }, {
    path: '/meishu',
    name: 'meishu',
    component: () => import('../views/kcjs/meishu.vue')
  }, {
    path: '/yishu',
    name: 'yishu',
    component: () => import('../views/kcjs/yishu.vue')
  },

  {
    path: '/xyhd',
    name: 'xyhd',
    component: () => import('../views/xshd/xyhd.vue')
  },
  {
    path: '/xyhdDetail',
    name: 'xyhdDetail',
    component: () => import('../views/xshd/xyhdDetail')
  },

  {
    path: '/xszp',
    name: 'xszp',
    component: () => import('../views/xshd/xszp.vue')
  },
  // xszpDetail
  {
    path: '/xszpDetail',
    name: 'xszpDetail',
    component: () => import('../views/xshd/xszpDetail.vue')
  },
  {
    path: '/huojiang',
    name: 'huojiang',
    component: () => import('../views/xshd/huojiang.vue')
  },
  // huojiangDetail
  {
    path: '/huojiangDetail',
    name: 'huojiangDetail',
    component: () => import('../views/xshd/huojiangDetail.vue')
  },
  {
    path: '/gongyu',
    name: 'gongyu',
    component: () => import('../views/xshd/gongyu.vue')
  },
  // gongyuDetail
  {
    path: '/gongyuDetail',
    name: 'gongyuDetail',
    component: () => import('../views/xshd/gongyuDetail.vue')
  },

  {
    path: '/jlhf',
    name: 'jlhf',
    component: () => import('../views/gjjl/jlhf.vue')
  },
  {
    path: '/gjxm',
    name: 'gjxm',
    component: () => import('../views/gjjl/gjxm.vue')
  },
  // gjxmDetail
  {
    path: '/gjxmDetail',
    name: 'gjxmDetail',
    component: () => import('../views/gjjl/gjxmDetail.vue')
  },
  {
    path: '/jlhfDetail',
    name: 'jlhfDetail',
    component: () => import('../views/gjjl/jlhfDetail.vue')
  },
  {
    path: '/lxfs',
    name: 'lxfs',
    component: () => import('../views/zsbm/lxfs.vue')
  },
  {
    path: '/xsc',
    name: 'xsc',
    component: () => import('../views/zsbm/xsc.vue')
  },
  {
    path: '/ysx',
    name: 'ysx',
    component: () => import('../views/zsbm/ysx.vue')
  },
  {
    path: '/ysxdetail',
    name: 'xsc',
    component: () => import('../views/zsbm/ysxdetail.vue')
  },
  {
    path: '/csg',
    name: 'csg',
    component: () => import('../views/zsbm/csg.vue')
  }, {
    path: '/zx',
    name: 'zx',
    component: () => import('../views/zsbm/zx.vue')
  }, {
    path: '/xyhdbm',
    name: 'xyhdbm',
    component: () => import('../views/zsbm/xyhdbm.vue')
  },
  // xyhdbmDetail
  {
    path: '/xyhdbmDetail',
    name: 'xyhdbmDetail',
    component: () => import('../views/zsbm/xyhdbmDetail.vue')
  },


  {
    path: '/cfxy',
    name: 'cfxy',
    component: () => import('../views/zsbm/cfxy.vue')
  },
  // xscDetail
  {
    path: '/xscDetail',
    name: 'xscDetail',
    component: () => import('../views/zsbm/xscDetail.vue')
  },
  {
    path: '/csgDetail',
    name: 'csgDetail',
    component: () => import('../views/zsbm/csgDetail.vue')
  },
  {
    path: '/zxDetail',
    name: 'zxDetail',
    component: () => import('../views/zsbm/zxDetail.vue')
  },
  {
    path: '/cfxyDetail',
    name: 'cfxyDetail',
    component: () => import('../views/zsbm/cfxyDetail.vue')
  },
  {
    path: '/zpjz',
    name: 'zpjz',
    component: () => import('../views/jrwm/zpjz.vue')
  },
  {
    path: '/zpjzDetail',
    name: 'zpjzDetail',
    component: () => import('../views/jrwm/zpjzDetail.vue')
  },
  {
    path: '/gwxq1',
    name: 'gwxq1',
    component: () => import('../views/jrwm/gwxq1.vue')
  },


  {
    path: '/xiaoche',
    name: 'xiaoche',
    component: () => import('../views/fwbz/xiaoche.vue')
  },
  // xiaocheDetail

  {
    path: '/xiaocheDetail',
    name: 'xiaocheDetail',
    component: () => import('../views/fwbz/xiaocheDetail.vue')
  },
  {
    path: '/canyin',
    name: 'canyin',
    component: () => import('../views/fwbz/canyin.vue')
  },

  // canyinDetail

  {
    path: '/canyinDetail',
    name: 'canyinDetail',
    component: () => import('../views/fwbz/canyinDetail.vue')
  },
  {
    path: '/xiaofu',
    name: 'xiaofu',
    component: () => import('../views/fwbz/xiaofu.vue')
  },
  // xiaofuDetail
  {
    path: '/xiaofuDetail',
    name: 'xiaofuDetail',
    component: () => import('../views/fwbz/xiaofuDetail.vue')
  },
  {
    path: '/zhusu',
    name: 'zhusu',
    component: () => import('../views/fwbz/zhusu.vue')
  },
  // zhusuDetail
  {
    path: '/zhusuDetail',
    name: 'zhusuDetail',
    component: () => import('../views/fwbz/zhusuDetail.vue')
  },
  {
    path: '/h5page',
    name: 'h5page',
    component: () => import('../views/h5page')
  },
{
  path: '/xuanke',
  name: 'xuanke',
  component: () => import('../views/xuanke')
},





]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return {
      x: 0,
      y: 0
    }
  }
})

export default router